export default __webpack_public_path__ + "static/media/blog-39-2.81d390d7.png";